import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { getAccessToken } from '../../../functions/authentication';
import { fetchUserInfo } from '../../../functions/user';
import Loader from '../../Loader';
import PageLayout from '../../PageLayout';

function Profile({ onError }) {
    const { t } = useTranslation('messages');
    const [userInfo, setUserInfo] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchUserInfo(
            (data) => {
                setUserInfo(data.user);
                setLoading(false);
            },
            (errorCode, errorDescription) => {
                setLoading(false);
                onError(errorCode, errorDescription);
            },
            getAccessToken()
        );
    }, [onError]);

    const fields = userInfo ? [
        { key: 'firstname',  value: userInfo.firstname },
        { key: 'lastname',   value: userInfo.lastname },
        { key: 'username',   value: userInfo.username },
        { key: 'email',      value: userInfo.email },
        { key: 'userId',     value: userInfo.userId },
    ] : [];

    return (
        <PageLayout
            hero={<h1 className="display-5 fw-bold mb-0">{t('profile.title')}</h1>}
            heroCenter
            mainPadding="py-5"
        >
            {loading ? (
                <Loader />
            ) : (
                <Row className="justify-content-center">
                    <Col xs={12} md={8} lg={6}>
                        <div className="card border-0 shadow-sm">
                            <div className="card-body p-4">
                                <dl className="row mb-0">
                                    {fields.map(({ key, value }) => (
                                        <>
                                            <dt key={`dt-${key}`} className="col-sm-4 text-muted fw-normal">
                                                {t(`profile.field_${key}`)}
                                            </dt>
                                            <dd key={`dd-${key}`} className="col-sm-8 fw-semibold mb-3">
                                                {value}
                                            </dd>
                                        </>
                                    ))}
                                </dl>
                            </div>
                        </div>
                    </Col>
                </Row>
            )}
        </PageLayout>
    );
}

export default Profile;
